var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('svg',{staticClass:"svg-icon",class:_vm.iconClass,attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.name}}),_vm._v("icon-pft_icon_close ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }